<template>
  <v-dialog
    class='sensitivity-filter-popup'
    :value="visiblePopup"
    :max-width="400"
    @click:outside="onNoClickButton()"
    @keydown.esc="onNoClickButton()"
  >
    <v-card class="popup-wrapper">
      <div class="title">{{$t(title)}}</div>
      <div class='sensitivity-wrapper'>
        <v-chip-group
          active-class='primary--text'
          column
          :key="visiblePopup"
        >
          <v-chip
            v-for="(sensitivity, index) in sensitivityOptions"
            :key="index"
            @click='addChip(sensitivity)'
            class='sensitivity'
            :class="[sensitivity, { 'is-selected': selectedSensitivity === sensitivity }]"
            :style="selectedSensitivity === sensitivity ? { color: 'var(--brand-primary)', backgroundColor: 'var(--brand-primary-bg)' } : {}"
          >
            {{ sensitivity }}
          </v-chip>
        </v-chip-group>
      </div>
      <div class="buttons">
        <v-btn v-if='showNoButton' small depressed class="no-button btn-secondary" @click="onNoClickButton()">
          {{$t(noCaption)}}
        </v-btn>
        <v-btn small depressed class="yes-button btn-primary" @click="onYesClickButton()" :disabled='saveDisabled'>
          {{$t(yesCaption)}}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>

</template>

<script>
import { CONFIGURATION } from '@/constants/configuration';
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';

export default {
  name: 'SelectSensitivityFilterPopup',
  mixins: [disableOuterScrollOnPopupVisible],
  props: {
    title: String,
    yesCaption: String,
    noCaption: String,
    showNoButton: {
      type: Boolean,
      default: true,
      required: false,
    },
    visiblePopup: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      selectedSensitivity: '',
    };
  },
  methods: {
    onYesClickButton() {
      this.$emit('clicked', this.selectedSensitivity);
      this.selectedSensitivity = '';
    },
    onNoClickButton() {
      this.$emit('clicked', false);
      this.selectedSensitivity = '';
    },
    addChip(sensitivity) {
      if (this.selectedSensitivity === sensitivity) {
        this.selectedSensitivity = '';
      } else {
        this.selectedSensitivity = sensitivity;
      }
    },
  },
  computed: {
    sensitivityOptions() {
      return Object.values(CONFIGURATION.SensitivityOptions).map(option => option.charAt(0).toUpperCase() + option.slice(1));
    },
    saveDisabled() {
      return this.selectedSensitivity.length === 0;
    },
  },
};
</script>

<style lang='scss'>
.sensitivity-wrapper {
  .v-slide-group__wrapper {
    padding-left: 32px !important;
  }
}
</style>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';
.popup-wrapper {
  max-width: rem(400);
  min-width: rem(400);
  padding: rem(32) rem(40);
  .sensitivity-wrapper {
    min-width: rem(400);
    margin-left: -11%;
    margin-bottom: rem(-20);
    .sensitivity {
      margin-bottom: rem(6);
      background: rgb(43, 175, 105, 0.2);
      border-radius: $radius-sm;
      width: rem(75);
      height: rem(28);
      color: #2BAF69;
      justify-content: center;
      display: flex;
      &.High {
        // TLD has 3 variants (low/medium/high) — high is max severity, maps to critical (red)
        // !important needed to override global .v-chip.sensitivity.High rule (orange)
        color: var(--severity-critical) !important;
        background-color: var(--severity-critical-bg) !important;
      }
      &.Medium {
        color: var(--severity-medium);
        background-color: var(--severity-medium-bg);
      }
      &.Low {
        color: var(--severity-low);
        background-color: var(--severity-low-bg);
      }

      &.is-selected {
        color: var(--brand-primary) !important;
        background-color: var(--brand-primary-bg) !important;
      }
    }
  }

  .title {
    color: var(--text-primary);
    font-size: rem(14) !important;
    font-weight: 600;
    letter-spacing: rem(1.12);
    line-height: rem(16);
    text-transform: uppercase;
    padding-bottom: rem(23);
  }

  .buttons {

    text-align: right;
    padding-top: rem(30);

    .no-button {
      box-sizing: border-box;
      height: rem(32);
      width: rem(86);
      border: 1px solid var(--brand-primary);
      color: var(--brand-primary);
      border-radius: $radius-sm;
      background-color: var(--bg-primary);
      box-shadow: $shadow-sm;
    }

    .yes-button {
      height: rem(32);
      width: rem(51);
      border-radius: $radius-sm;
      box-shadow: $shadow-sm;
      font-size: rem(12);
      font-weight: 500;
      letter-spacing: rem(1.07);
      line-height: rem(16);
      text-align: center;
      margin-left: rem(8);
    }

  }
}

</style>
